<list-view [liste]="geographieService.listeVilles" *ngIf="geographieService.listeVilles"></list-view>
<floating-button [listeActions]="listeActions"></floating-button>